import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.56 5.44a1.5 1.5 0 1 0-2.12 2.12l4.939 4.94-4.94 4.94a1.5 1.5 0 0 0 2.122 2.12l4.939-4.939 4.94 4.94a1.5 1.5 0 0 0 2.12-2.122L14.622 12.5l4.94-4.94a1.5 1.5 0 0 0-2.122-2.12l-4.94 4.938-4.94-4.94Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHide;
